const COMMON_FETCH_METADATA = {
  START: 'START_COMMON_FETCH_METADATA',
  COMPLETE: 'COMPLETE_COMMON_FETCH_METADATA',
  FAIL: 'FAIL_COMMON_FETCH_METADATA',
  CLEANUP: 'CLEANUP_COMMON_FETCH_METADATA',
}

export default COMMON_FETCH_METADATA
